// src/constants/FeaturedConstants.js

// Import PNG images
import pod1Img from '../../placeholders/images/pod-1.png';
import pod2Img from '../../placeholders/images/pod-2.png';
import pod5Img from '../../placeholders/images/pod-5.png';

// Import WAV audio
import pod1Audio from '../../placeholders/audio/pod-1.wav';
import pod2Audio from '../../placeholders/audio/pod-2.mp3';
import pod5Audio from '../../placeholders/audio/pod-5.wav';

const FEATURED_PODCASTS = [
    {
      id: 'pod-1',
      title: 'A City on Mars: Dreams of Settlement Meet Stark Realities',
      publishedBy: 'futurethink',
      imageUrl: pod1Img,
      audioUrl: pod1Audio,
      duration: 267,
      likes: 42,
      description:
        'Unpacking the Weinersmith\'s eye-opening book on the true challenges of colonizing space. From life support systems to sex in zero gravity, explore why building cities beyond Earth is far more complex than science fiction suggests.',
    },
    {
      id: 'pod-2',
      title: 'Unlocking the Scaling Laws of Compute',
      publishedBy: 'techcrunchy',
      imageUrl: pod2Img,
      audioUrl: pod2Audio,
      duration: 145,
      likes: 89,
      description:
        'How exponential computing power is revolutionizing AI and reshaping our future. Dive into the principles driving breakthrough performance in neural networks and discover how scaling laws affect AI models.',
    },
    {
      id: 'pod-5',
      title: 'Polymarket\'s Rise: Betting on Tomorrow\'s Headlines',
      publishedBy: 'FinanceToday',
      imageUrl: pod5Img,
      audioUrl: pod5Audio,
      duration: 145,
      likes: 67,
      description:
        'Discover how this crypto prediction market outpaced polls and navigated regulatory storms to forecast global events. From elections to sports indicators, learn why decentralized prediciotns markets are becoming the new frontier of real-time forecasting.',
    },
  ];

export const getFeaturedPodcasts = () => FEATURED_PODCASTS;
